import { Form, Modal, Row, Space } from 'antd';
import React from 'react';
import TextArea from 'antd/lib/input/TextArea';
import FileUploadItem from './file-upload-item';
import { FileTypes } from '../false-deals-admin.types';
import Button from '/react4xp/mixins/ui/button/button';
import { DELETION_FILESIZE_LIMIT, DELETION_FILES_LIMIT } from '../false-deals-admin.constants';

const DeleteFalseDealsModal = ({ isModalOpen, handleCancel, handleOk, deleteForm }) => {
    return (
        <Modal
            title="Удалить лжесделку"
            open={isModalOpen}
            onCancel={handleCancel}
            footer={null}
        >
            <Form
                name="delete-form"
                form={deleteForm}
                layout="vertical"
                onFinish={handleOk}
            >
                <Form.Item
                    name="id"
                    hidden
                ></Form.Item>
                <Form.Item
                    name="cause"
                    label="Причина удаления"
                    rules={[
                        { min: 50, message: 'Минимальное количество символов: 50' },
                        { required: true, message: 'Поле обязательно для заполнения' },
                    ]}
                >
                    <TextArea
                        rows={4}
                        placeholder="Введите обоснование"
                        className="input"
                        minLength={50}
                    />
                </Form.Item>
                <FileUploadItem
                    form={deleteForm}
                    name={FileTypes.DELETION}
                    required={false}
                    totalFiles={DELETION_FILES_LIMIT}
                    totalFileSize={DELETION_FILESIZE_LIMIT}
                />
                <Row justify="end">
                    <Space>
                        <Form.Item>
                            <Button onClick={handleCancel}>Отменить</Button>
                        </Form.Item>
                        <Form.Item>
                            <Button
                                htmlType="submit"
                                color="gold"
                            >
                                Удалить лжесделку
                            </Button>
                        </Form.Item>
                    </Space>
                </Row>
            </Form>
        </Modal>
    );
};

export default DeleteFalseDealsModal;
